/**
 * Alpine.js integration helpers for Shadow DOM.
 *
 * Alpine doesn't natively observe inside shadow roots,
 * so we manually destroy / re-init trees after HTMX swaps.
 */

/**
 * Destroy Alpine state on a subtree before it is replaced.
 * Safe to call even when Alpine is not loaded.
 *
 * @param {HTMLElement} target - root of the subtree being removed
 */
export function destroyTree(target) {
    if (!window.Alpine) return;
    if (target._x_dataStack || target.querySelector('[x-data]')) {
        window.Alpine.destroyTree(target);
    }
}

/**
 * Initialise Alpine on a freshly-injected subtree and make sure
 * Alpine's mutation observer covers the shadow root.
 *
 * Called inside a `requestAnimationFrame` so the DOM has settled.
 *
 * @param {ShadowRoot} shadowRoot
 * @param {HTMLElement} element - the swapped-in element
 */
export function initTree(shadowRoot, element) {
    if (!window.Alpine) return;

    requestAnimationFrame(() => {
        window.Alpine.initTree(element);
        window.Alpine.flushAndStopDeferringMutations();
        window.Alpine.startObservingMutations(shadowRoot);
    });
}